<div *ngIf="componentData" class="duo-tone-ad-container {{textStyle}}"
     [ngStyle]="{'border-top-color': backgroundColor, 'background-color': backgroundColor2}">
    <div class="duo-tone-ad-wrapper">
        <div class="flex-col">
            <img class="img-fluid" src="{{mobileImagePath}}" alt="">
        </div>
        <div class="flex-col-text">
            <h3 class="heading-3">{{translationRoot + '.title' | translate:useLocaleOverride}}</h3>
            <p>{{translationRoot + '.body' | translate:useLocaleOverride}}</p>
            <div>
                <button *ngIf="componentData.includeCallToAction" type="button"
                        class="button button-large {{buttonType}}"
                        (click)="callToActionClick()">
                    {{translationRoot + '.button' | translate:useLocaleOverride}}
                </button>
            </div>
        </div>
    </div>
</div>
